import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { FC } from "react";
import { registrationLnsw } from '../services/LnswSubmission';
import { DataPuProyek } from 'modules/Pu/services/types';
import { DataRegistration } from 'modules/Registration/services/types';

export interface LnswCardPraSubmissionProps {
    className?: string;
    isLiked?: boolean;
    praSubmission?: registrationLnsw;
    submission?: DataPuProyek;
    oldsubmission?: DataRegistration;
}

const LnswCardSubmission: FC<LnswCardPraSubmissionProps> = ({ className = "", isLiked, praSubmission, submission, oldsubmission }) => {
    if (oldsubmission) {
        return (
            <div className="rounded-xl bg-white p-3 shadow-sm">
                <Disclosure defaultOpen>
                    {({ open }) => (
                        <>
                            <Disclosure.Button className="flex w-full justify-between">
                                <div className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                    <span>
                                        # {oldsubmission.RefJenisProduk.RefDesc?.toString().toUpperCase()}
                                    </span>
                                    <ChevronUpIcon
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5 text-purple-500`}
                                    />
                                </div>
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                                {oldsubmission.NamaPuAlt}
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            </div >

        )
    }


    if (submission) {
        return (
            <div className="rounded-xl bg-white p-3 shadow-sm">
                <Disclosure defaultOpen>
                    {({ open }) => (
                        <>
                            <Disclosure.Button className="flex w-full justify-between">
                                <div className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                    <span>
                                        # 1 {submission?.Kbli}
                                    </span>
                                    <ChevronUpIcon
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5 text-purple-500`}
                                    />
                                </div>
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                                {submission?.UraianUsaha}
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            </div >

        )
    }

    return (
        <div className="rounded-xl bg-white p-3 shadow-sm">
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button className="flex w-full justify-between">
                            <div className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                <span>
                                    # 1 {praSubmission?.Kbli}
                                </span>
                                <ChevronUpIcon
                                    className={`${open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-purple-500`}
                                />
                            </div>
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                            {/* {dataNIB?.dataProdukHalal.uraianJenisProduk} */}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div >
        // <div>
        //     <div className="flex flex-row space-x-4 rounded-xl bg-white p-3 shadow-sm">
        //         <div className="w-6">
        //             <NewspaperIcon className="text-gray-500 aspect-square w-8 rounded-lg bg-center object-cover" />
        //         </div>
        //         <div className="w-full">
        //             <h4 className="font-semibold text-gray-600">
        //                 {dataNIB?.dataProdukHalal.flagSelfDeclare === 'Y' ? 'Selfdeclare' : 'Reguler'}
        //             </h4>
        //             <p className="text-sm text-slate-400">
        //                 {dataNIB?.dataProdukHalal.uraianJenisProduk}
        //             </p>
        //         </div>

        //     </div>
        //     <div className="w-full px-4 pt-16">
        //         <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">

        //             <Disclosure as="div" className="mt-2">
        //                 {({ open }) => (
        //                     <>
        //                         <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
        //                             <span>Do you offer technical support?</span>
        //                             <ChevronUpIcon
        //                                 className={`${open ? 'rotate-180 transform' : ''
        //                                     } h-5 w-5 text-purple-500`}
        //                             />
        //                         </Disclosure.Button>
        //                         <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
        //                             No.
        //                         </Disclosure.Panel>
        //                     </>
        //                 )}
        //             </Disclosure>
        //         </div>
        //     </div>
        // </div>
        // <div
        //     className={`nc-LnswCardSubmission relative flex flex-col group border-1 [ nc-box-has-hover-sequare ] ${className}`}
        //     data-nc-id="LnswCardSubmission"
        // >
        //     <div className="p-4 py-5 ">
        //         <div className="text-neutral-700 text-xs font-bold">Jenis Submission</div>
        //         <p className="text-neutral-700  text-xs leading-4 mb-2">
        //             {dataNIB?.dataProdukHalal.flagSelfDeclare === 'Y' ? 'Selfdeclare' : 'Reguler'}
        //         </p>

        //         <div className="text-neutral-700 text-xs font-bold">Jenis Produk</div>
        //         <p className="text-neutral-700  text-xs leading-4 mb-2">
        //             {dataNIB?.dataProdukHalal.uraianJenisProduk}
        //         </p>

        //         <div className="text-neutral-700 text-xs font-bold">Daftar Produk</div>
        //         {
        //             dataNIB?.dataProdukHalal.listProduk.map((value, index) => {
        //                 return (
        //                     <div key={`listProduk-${index}`} className="w-full text-xs border-b border-neutral-100 dark:border-neutral-700">
        //                         - {value.uraianProduk}
        //                     </div>
        //                 )
        //             })
        //         }

        //         <div className="text-neutral-700 text-xs font-bold mt-2">Ketarangan</div>
        //         <p className="text-neutral-700  text-xs leading-4 mb-2">
        //             Submission dengan jenis produk tersebut sudah dibuat
        //         </p>

        //         <div className="flex flex-row gap-2 h-8 justify-between items-between">
        //             <ButtonSecondary
        //                 // disabled={!client}
        //                 // loading={isFetching}
        //                 // sizeClass="px-5 py-2 sm:px-1"
        //                 // className="w-full"
        //                 type="button"
        //             // onClick={() => doLogout()}
        //             >
        //                 <span className="whitespace-nowrap text-xs py-5">Buat baru</span> <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" />
        //             </ButtonSecondary>
        //             <ButtonPrimary
        //                 // disabled={!client}
        //                 // loading={isFetching}
        //                 // className="w-full"
        //                 // sizeClass="px-2 py-1 sm:px-1"
        //                 type="button"
        //             // onClick={() => doSelanjutnnyya()}
        //             >
        //                 <span className="text-sm text-xs">Lanjutkan</span> <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" />
        //             </ButtonPrimary>
        //         </div>

        //         <div className="flex flex-col space-x-3 w-full h-8">


        //         </div>
        //     </div>

        //     {/* <Link to={"/nft-detailt"} className="absolute inset-0"></Link> */}
        // </div >
    );
};

export default LnswCardSubmission;
